










































import { DynamicDocumentItem, DynamicDocumentItemData, InstallationModuleData } from "@/types";
import Vue, { PropType } from "vue";

import eventbus from "@/utilities/eventbus";
import { isItemRequired } from "@/utilities";

type Message = {
  text: string;
  value: string;
};

export default Vue.extend({
  props: {
    icon: String,
    items: Array as PropType<DynamicDocumentItem[]>,
    data: Array as PropType<DynamicDocumentItemData[]>,
    moduleData: Object as PropType<InstallationModuleData>,
    index: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    itemsData(): Array<{ item: DynamicDocumentItem; data: DynamicDocumentItemData }> {
      return this.items.map(item => ({ item, data: this.data.find(d => d.field === item.field)! }));
    },

    invalid(): number {
      return this.itemsData.filter(item => item.data.isValid === false).length;
    },

    required(): Message[] {
      return this.itemsData.flatMap(item => {
        if (!isItemRequired(item.item, this.data, this.moduleData)) return [];

        if (item.data.validation === false)
          return [{ text: `Vraag: ${item.item.title}`, value: item.item.field }];
        if (typeof item.data.validation === "string")
          return [{ text: item.data.validation, value: item.item.field }];
        if (item.data.validation instanceof Array)
          return item.data.validation.map(error => ({ text: error, value: item.item.field }));

        return [];
      });
    },

    optional(): Message[] {
      return this.itemsData.flatMap(item => {
        if (isItemRequired(item.item, this.data, this.moduleData)) return [];

        if (item.data.validation === false)
          return [{ text: `Vraag: ${item.item.title}`, value: item.item.field }];
        if (typeof item.data.validation === "string")
          return [{ text: item.data.validation, value: item.item.field }];
        if (item.data.validation instanceof Array)
          return item.data.validation.map(error => ({ text: error, value: item.item.field }));

        return [];
      });
    },

    color(): string {
      if (this.required.length > 0) {
        return "error";
      }

      return "success";
    }
  },

  methods: {
    navTo(field: string) {
      eventbus.$emit("expand:open", this.index);

      setTimeout(() => this.$vuetify.goTo(`#${field}`, { offset: 100 }), 300);
    }
  }
});
